import PremissasEquipamentosView from "../../components/gestaoOrcamentaria/PremissasEquipamentosView";

export default function PremissasEquipamentos() {
  return <PremissasEquipamentosView />;
}
